import { checkCondition } from '@/utils'

interface Single {
  required?: boolean | { if: any } | { unless: any }
  variable: string
}

interface Multi {
  scales: Single[]
}

export type Requirable = Single | Multi

function isSingle(requirable: Requirable): requirable is Single {
  return typeof (requirable as Single).variable === 'string'
}

function isMulti(requirable: Requirable): requirable is Multi {
  return (requirable as Multi).scales !== undefined
}

export function getRequiredVariables(items: Requirable[], values: any): string[] {
  return items.flatMap(item => {
    if (isSingle(item) && checkCondition(item.required, values)) {
      return [item.variable]
    } else if (isMulti(item)) {
      return item.scales
        .filter(scale => checkCondition(scale.required, values))
        .map(scale => scale.variable)
    } else {
      return []
    }
  })
}

export function missingRequiredVariables(items: Requirable[], values: any): string[] {
  return getRequiredVariables(items, values).filter(
    variable => values[variable] === null || values[variable] === undefined
  )
}

export function allRequiredVariablesArePresent(items: Requirable[], values: any): boolean {
  return missingRequiredVariables(items, values).length === 0
}
